import { render, staticRenderFns } from "./ResourceWriteDialog.vue?vue&type=template&id=0088054e&"
import script from "./ResourceWriteDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceWriteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports